import * as React from 'react';
import { Icon } from 'ui/common/icon';
import { FactLink } from 'app/area/case/components/fact-box/fact-link';
import { BadgeList } from 'ui/badge-list';
import { FactItemProps } from 'app/area/case/components/fact-box/types';
import { ComplexValue, ComponentProps } from 'ui/common';
import styles from 'app/area/case/components/fact-box/fact-box.scss';

interface ConnectedCasesIntegrityStatusFactItemProps extends ComponentProps, FactItemProps {
  connectedIntegrityStatus: ComplexValue<number>;
  connectedIntegrityScore: number;
}

export const ConnectedCasesIntegrityStatusFactItem = (props: ConnectedCasesIntegrityStatusFactItemProps) => {
  const { connectedIntegrityStatus, connectedIntegrityScore, title, linkDomain, url, urlOpenNew } = props;
  const iconIntegrityStatus = connectedIntegrityStatus ? <Icon url={connectedIntegrityStatus.icon} /> : null;

  const items = [{ key: 1, value: connectedIntegrityScore, tooltip: connectedIntegrityStatus?.description }];

  if (!connectedIntegrityStatus?.value) {
    return null;
  }
  return <li className={`${styles.factLink} fact-item`}>
    <FactLink id={props.componentId} classNames={styles.factLink} section={linkDomain} url={url} urlOpenNew={urlOpenNew}>
      <BadgeList
        icon={iconIntegrityStatus}
        title={title}
        valueItems={items}
      />
    </FactLink>
  </li>;
};
